host.actions.register({
    // #region Vars
    name: '288a.identity.user.changename',
    // #endregion
    // #region Entry
    async execute(data, params) {
        alert('Test');
        return this.Window(await host.notification.showModal2("g-account-username_change"));
    },
    // #endregion
});
export {};
